import React from 'react';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

interface Props {
  testId?: string;
}

export const TotalCountSectionLoader = ({ testId = 'total-count-section-loader' }: Props) => {
  const loaderWidth = 15;
  const marginRight = 2;
  const totalCountLoaderWidth = loaderWidth + '%';
  const totalCountMarginRight = marginRight + '%';

  return (
    <div data-testid={testId}>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width={totalCountLoaderWidth} isRightAligned />
        <SkeletonLoader width={totalCountLoaderWidth} marginRight={totalCountMarginRight} isRightAligned />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width={totalCountLoaderWidth} isRightAligned />
        <SkeletonLoader width={totalCountLoaderWidth} marginRight={totalCountMarginRight} isRightAligned />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width={totalCountLoaderWidth} isRightAligned />
        <SkeletonLoader width={totalCountLoaderWidth} marginRight={totalCountMarginRight} isRightAligned />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width={loaderWidth * 2 + marginRight + 0.7 + '%'} height="1px" isRightAligned />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width={totalCountLoaderWidth} isRightAligned />
        <SkeletonLoader width={totalCountLoaderWidth} marginRight={totalCountMarginRight} isRightAligned />
      </SkeletonLoaderWrapper>
    </div>
  );
};
